import { Box } from "@mui/material";
import { Alert } from "@platform/design-system";

import { extractErrorMessage } from "../../utils";

type Props = {
  error: unknown;
  defaultError: string;
};

function ErrorMessage({ error, defaultError }: Props): React.JSX.Element {
  return (
    <Box mt={2} mb={2}>
      <Alert severity="error">{extractErrorMessage(error, defaultError)}</Alert>
    </Box>
  );
}

export default ErrorMessage;
